import { useCallback, useContext } from 'react';

import { TokenContext } from '@/Contexts/TokenContext';
import { PartnerSubCategoryApiResponse } from '@/models/Program';
import { baseUrl } from '@/utils/constants';

import { useCustomFetch } from './useCustomFetch';

export default function usePartnerSubCategory() {
  const { authResult } = useContext(TokenContext);
  const { customFetch } = useCustomFetch();

  const getPartnerSubCategories = useCallback(async (): Promise<
    PartnerSubCategoryApiResponse[] | null
  > => {
    const fetchUrl = `${baseUrl}PartnerSubCategories`;

    const results = await customFetch<PartnerSubCategoryApiResponse[]>(fetchUrl, {
      method: 'GET',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
        Authorization: `Bearer ${authResult.accessToken}`,
      },
    });

    return results;
  }, [authResult, customFetch]);

  return {
    getPartnerSubCategories,
  };
}
